/**
 *  @class
 *  @function SlideShow
 */

function getCarouselSlideAccessibleLabel(slide, index) {
  if (!slide) return 'Slide ' + (index + 1);
  var h1 = slide.querySelector('h1');
  if (h1 && h1.textContent.trim()) {
    return h1.textContent.trim().replace(/\s+/g, ' ');
  }
  var sub = slide.querySelector('.subheading');
  if (sub && sub.textContent.trim()) {
    return sub.textContent.trim().replace(/\s+/g, ' ');
  }
  var author = slide.querySelector('.testimonials__author');
  if (author && author.textContent.trim()) {
    return author.textContent.trim().replace(/\s+/g, ' ');
  }
  var testimonialP = slide.querySelector('.testimonials__testimonial p');
  if (testimonialP && testimonialP.textContent.trim()) {
    var t2 = testimonialP.textContent.trim().replace(/\s+/g, ' ');
    return t2.length > 80 ? t2.slice(0, 77) + '…' : t2;
  }
  var heading = slide.querySelector('.blog-post__title, h2, h3');
  if (heading && heading.textContent.trim()) {
    return heading.textContent.trim().replace(/\s+/g, ' ');
  }
  return 'Slide ' + (index + 1);
}

/**
 * Keeps non-visible carousel slides out of the accessibility tree so screen-reader
 * and keyboard users cannot reach off-screen content. Skips carousels that show
 * multiple interactive cells at once (product grids).
 */
function syncCarouselSlidesInert(flkty, slideshow) {
  if (!flkty || !slideshow) return;
  if (slideshow.classList.contains('products')) return;
  if (slideshow.classList.contains('collection-grid__carousel')) return;

  var slides = flkty.slides;
  function clearInertOnSlideCells(slide) {
    if (!slide || !slide.getCellElements) return;
    slide.getCellElements().forEach(function (el) {
      if (el) el.removeAttribute('inert');
    });
  }

  if (!slides || slides.length <= 1) {
    if (slides) {
      slides.forEach(clearInertOnSlideCells);
    }
    return;
  }

  var idx = flkty.selectedIndex;
  slides.forEach(function (slide, i) {
    if (!slide || !slide.getCellElements) return;
    slide.getCellElements().forEach(function (el) {
      if (!el) return;
      if (i === idx) {
        el.removeAttribute('inert');
      } else {
        el.setAttribute('inert', '');
      }
    });
  });
}

function flickityAutoplayIsRunning(flkty) {
  return Boolean(flkty && flkty.player && flkty.player.state === 'playing');
}

function slideshowAutoplayIntervalConfigured(slideshow) {
  var v = slideshow && slideshow.dataset && slideshow.dataset.autoplay;
  if (!v || v === 'false' || v === '0') return false;
  var n = parseInt(v, 10);
  return !isNaN(n) && n > 0;
}

function initCarouselAutoplayToggle(flkty, toggleBtn, options) {
  if (!flkty || !toggleBtn) return;

  var pauseLabel = (options && options.pauseLabel) || 'Pause slideshow';
  var playLabel = (options && options.playLabel) || 'Play slideshow';
  var autoplayInterval = options && options.autoplayInterval;
  var intervalMs = (options && options.intervalMs) || 5000;

  var statusEl = toggleBtn.querySelector('.carousel__autoplay-toggle-status');
  var playIcon = toggleBtn.querySelector('.icon-play');
  var pauseIcon = toggleBtn.querySelector('.icon-pause');
  var isPlaying = Boolean(autoplayInterval);

  function updateUi() {
    if (statusEl) {
      statusEl.textContent = isPlaying ? pauseLabel : playLabel;
    }
    if (playIcon && pauseIcon) {
      if (isPlaying) {
        pauseIcon.style.display = 'block';
        playIcon.style.display = 'none';
      } else {
        pauseIcon.style.display = 'none';
        playIcon.style.display = 'block';
      }
    }
    toggleBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
  }

  toggleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    isPlaying = !isPlaying;
    if (isPlaying) {
      flkty.options.autoPlay = typeof autoplayInterval === 'number' ? autoplayInterval : intervalMs;
      flkty.playPlayer();
    } else {
      flkty.stopPlayer();
    }
    updateUi();
  });

  flkty.on('pointerDown', function () {
    if (!isPlaying) return;
    isPlaying = false;
    flkty.stopPlayer();
    updateUi();
  });

  updateUi();
}

function getCarouselAutoplayLabels(slideshow) {
  if (slideshow.classList.contains('testimonials__carousel')) {
    return {
      pauseLabel: 'pause testimonials slideshow',
      playLabel: 'play testimonials slideshow'
    };
  }
  return {
    pauseLabel: 'pause hero slideshow',
    playLabel: 'play hero slideshow'
  };
}

function getCarouselAutoplayMountTarget(slideshow) {
  if (slideshow.classList.contains('testimonials__carousel')) {
    return slideshow.closest('.testimonials');
  }
  return slideshow;
}

function findCarouselAutoplayControls(slideshow, mountTarget) {
  if (mountTarget) {
    var inMountTarget = mountTarget.querySelector('.carousel__autoplay-controls');
    if (inMountTarget) return inMountTarget;
  }
  var inSlideshow = slideshow.querySelector('.carousel__autoplay-controls');
  if (inSlideshow) return inSlideshow;
  var wrapper = slideshow.closest('.main-slideshow-wrapper, .testimonials__carousel-wrapper');
  return wrapper && wrapper.querySelector('.carousel__autoplay-controls');
}

/**
 * Ensures pause/play UI is mounted in the correct container and visible.
 * Hero: inside the Flickity root. Testimonials: bottom-right of the full section.
 */
function mountCarouselAutoplayControls(flkty, slideshow, options) {
  if (!flkty || !slideshow || !slideshowAutoplayIntervalConfigured(slideshow)) return;

  var labels = getCarouselAutoplayLabels(slideshow);
  var pauseLabel = (options && options.pauseLabel) || labels.pauseLabel;
  var playLabel = (options && options.playLabel) || labels.playLabel;
  var autoplayInterval = options && options.autoplayInterval;
  var intervalMs = (options && options.intervalMs) || parseInt(slideshow.dataset.autoplayMs, 10) || 5000;
  var mountTarget = getCarouselAutoplayMountTarget(slideshow) || slideshow;

  var controls = findCarouselAutoplayControls(slideshow, mountTarget);

  if (!controls) {
    controls = document.createElement('div');
    controls.className = 'carousel__autoplay-controls';
    controls.innerHTML =
      '<button type="button" class="carousel__autoplay-toggle slideshow__autoplay-toggle" aria-pressed="true">' +
      '<span class="visually-hidden carousel__autoplay-toggle-status" aria-live="polite" aria-atomic="true">' +
      pauseLabel +
      '</span>' +
      '<svg class="icon-pause" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M7 5.5h2.5v9H7zM10.5 5.5h2.5v9h-2.5z" fill="currentColor"/>' +
      '</svg>' +
      '<svg class="icon-play" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" style="display:none;">' +
      '<path d="M7.5 5.5V14.5L15 10L7.5 5.5Z" fill="currentColor"/>' +
      '</svg>' +
      '</button>';
  }

  if (controls.parentElement !== mountTarget) {
    mountTarget.appendChild(controls);
  }

  var toggleBtn = controls.querySelector('.carousel__autoplay-toggle');
  if (!toggleBtn) return;
  if (toggleBtn.dataset.autoplayBound === 'true') return;
  toggleBtn.dataset.autoplayBound = 'true';

  initCarouselAutoplayToggle(flkty, toggleBtn, {
    pauseLabel: pauseLabel,
    playLabel: playLabel,
    autoplayInterval: autoplayInterval,
    intervalMs: intervalMs
  });
}

function enhanceFlickityPageDotsAccessibility(flkty, slideshow) {
  if (!flkty || !flkty.pageDots || !flkty.pageDots.holder) return;

  var live = document.createElement('div');
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  slideshow.insertBefore(live, slideshow.firstChild);

  /** Suppress the first live update when autoplay is enabled so SRs do not get a one-off before the player starts. */
  var suppressInitialLiveIfAutoplayEnabled = slideshowAutoplayIntervalConfigured(slideshow);

  flkty.pageDots.holder.setAttribute('aria-label', 'Slide indicators');

  function slides() {
    return Array.prototype.slice.call(slideshow.querySelectorAll('.carousel__slide'));
  }

  function syncDotButtons() {
    flkty.pageDots.dots.forEach(function (li, i) {
      if (li.querySelector('.flickity-dot-button')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'flickity-dot-button';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        flkty.uiChange();

        var targetIndex = i;

        function focusSelectedSlide() {
          var slideEls = slides();
          var el = slideEls[targetIndex];
          if (!el) return;
          el.setAttribute('tabindex', '-1');
          try {
            el.focus({ preventScroll: true });
          } catch (err) {
            el.focus();
          }
        }

        var onSettle = function () {
          flkty.off('settle', onSettle);
          focusSelectedSlide();
        };

        flkty.on('settle', onSettle);
        flkty.select(targetIndex);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!flkty.isAnimating) {
              flkty.off('settle', onSettle);
              focusSelectedSlide();
            }
          });
        });
      });
      li.appendChild(btn);
    });
  }

  function syncLiveRegionAnnouncementPolicy() {
    var autoRunning = flickityAutoplayIsRunning(flkty);
    if (autoRunning) {
      live.setAttribute('aria-live', 'off');
    } else {
      live.setAttribute('aria-live', 'polite');
    }
  }

  function announceAndLabelDots() {
    var slideEls = slides();
    var total = slideEls.length || flkty.slides.length;
    var idx = flkty.selectedIndex;
    var currentLabel = getCarouselSlideAccessibleLabel(slideEls[idx], idx);

    syncLiveRegionAnnouncementPolicy();

    var suppressLiveUpdate = false;
    if (suppressInitialLiveIfAutoplayEnabled) {
      suppressInitialLiveIfAutoplayEnabled = false;
      suppressLiveUpdate = true;
    }
    if (flickityAutoplayIsRunning(flkty)) {
      suppressLiveUpdate = true;
    }

    if (!suppressLiveUpdate) {
      live.textContent = 'Now showing ' + currentLabel + ' slide';
    } else {
      live.textContent = '';
    }

    flkty.pageDots.dots.forEach(function (li, i) {
      li.removeAttribute('aria-label');
      li.removeAttribute('aria-current');
      var label = getCarouselSlideAccessibleLabel(slideEls[i], i);
      var btn = li.querySelector('.flickity-dot-button');
      if (!btn) return;
      var position = 'Slide ' + (i + 1) + ' of ' + total;
      btn.setAttribute('aria-label', label + ', ' + position);
      if (i === idx) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
  }

  syncDotButtons();
  flkty.on('cellChange', function () {
    syncDotButtons();
    requestAnimationFrame(announceAndLabelDots);
  });
  flkty.on('select', function () {
    requestAnimationFrame(announceAndLabelDots);
  });
  requestAnimationFrame(announceAndLabelDots);
}

if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;

      let dots = slideshow.dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelectorAll('.flickity-custom-dots'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        currentIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: dots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide'
        };
      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__content')) {
        args.adaptiveHeight = true;
      }
      if (
        slideshow.classList.contains('image-with-text-slideshow__image') ||
        slideshow.classList.contains('image-with-text-slideshow__content')
      ) {
        const existingOn = args.on;
        args.on = {
          ready: function () {
            if (existingOn && typeof existingOn.ready === 'function') {
              existingOn.ready.call(this);
            }
            const root = slideshow.closest('.image-with-text-slideshow');
            if (!root) return;
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                ['.image-with-text-slideshow__image', '.image-with-text-slideshow__content'].forEach(function (sel) {
                  const node = root.querySelector(sel);
                  const f = node && Flickity.data(node);
                  if (f) f.resize();
                });
              });
            });
          }
        };
      }
      if (slideshow.classList.contains('testimonials__carousel')) {
        args.adaptiveHeight = true;
        args.on = {
          ready: function () {
            window.dispatchEvent(new Event('resize'));
          }
        };
      }
      if (slideshow.classList.contains('collection-grid__carousel')) {
        if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
          args.on = {
            scroll: function (progress) {
              let flkSlideWidth = slideshow.querySelectorAll('.collection-card')[0].clientWidth + 25,
                extra_window_space = slideshow.getBoundingClientRect().left;

              this.slides.forEach((the_slide, j) => {

                let scale_amount = 1,
                  translateX_amount = 0,
                  rotate_amount = 0,
                  zindex = 10,
                  opacity_amount = 1,
                  slide = the_slide.cells[0].element,
                  slide_offset = slide.getBoundingClientRect().left;

                if (slide_offset - extra_window_space < 0) {

                  scale_amount = 1 + ((slide_offset - extra_window_space) / 1200);
                  opacity_amount = 1 + ((slide_offset - extra_window_space) / 200);
                  translateX_amount = ((slide_offset - extra_window_space)) * -1;
                  rotate_amount = ((slide_offset - extra_window_space) / 10) * -1;

                } else {
                  scale_amount = 1;
                  opacity_amount = 1;
                  translateX_amount = 0;
                  rotate_amount = 0;
                }

                if (slide_offset + 5 - extra_window_space < 0) {
                  zindex = 5;
                } else {
                  zindex = 10;
                }

                slide.style.zIndex = zindex;

                gsap.set(slide.querySelector('.collection-card--inner'), {
                  'transform': 'perspective(1000px) translateX(' + translateX_amount + 'px) rotateY(' + rotate_amount + 'deg) translateZ(0)',
                  'opacity': opacity_amount
                });

                gsap.set(slide.querySelector('.collection-card__link'), {
                  'transform': 'scale(' + scale_amount + ') translateZ(0)'
                });

              });
            }
          };
        }

      }
      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
        if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
          slideshow.prepareAnimations(slideshow, animations);
          args.on = {
            ready: function () {
              slideshow.animateSlides(0, slideshow, animations);
            },
            change: function (index) {
              let previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);

              slideshow.animateReverse(previousIndex, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }
          };
        }
      }
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on = {
          ready: function () {
            var flickity = this;
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, prev_button, next_button);
            });
            window.dispatchEvent(new Event('resize.center_arrows'));
          }
        };
      }
      const flkty = new Flickity(slideshow, args);

      slideshow.dataset.initiated = true;

      syncCarouselSlidesInert(flkty, slideshow);
      flkty.on('select', function () {
        syncCarouselSlidesInert(flkty, slideshow);
      });
      flkty.on('settle', function () {
        syncCarouselSlidesInert(flkty, slideshow);
      });

      if (dots && flkty.pageDots) {
        enhanceFlickityPageDotsAccessibility(flkty, slideshow);
      }

      var intervalMs = parseInt(slideshow.dataset.autoplayMs, 10) || 5000;
      mountCarouselAutoplayControls(flkty, slideshow, {
        autoplayInterval: autoplay,
        intervalMs: intervalMs
      });
      flkty.on('ready', function () {
        mountCarouselAutoplayControls(flkty, slideshow, {
          autoplayInterval: autoplay,
          intervalMs: intervalMs
        });
      });

      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.uiChange();
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.uiChange();
          flkty.next();
        });
      }

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        document.fonts.ready.then(function () {
          new SplitText(slideshow.querySelectorAll('h1, p:not(.subheading)'), {
            type: 'lines, words',
            linesClass: 'line-child'
          });
          slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
            let tl = gsap.timeline({
              paused: true
            }),
              button_offset = 0;


            animations[i] = tl;

            tl
              .to(item.querySelector('.slideshow__slide-content'), {
                duration: 0,
                autoAlpha: 1
              });
            if (item.querySelector('.subheading')) {
              tl
                .fromTo(item.querySelector('.subheading'), {
                  opacity: 0
                }, {
                  duration: 0.5,
                  opacity: 0.6
                }, 0);

              button_offset += 0.5;
            }
            if (item.querySelector('h1')) {
              let h1_duration = 0.5 + ((item.querySelectorAll('h1 .line-child div').length - 1) * 0.05);
              tl
                .from(item.querySelectorAll('h1 .line-child div'), {
                  duration: h1_duration,
                  yPercent: '100',
                  stagger: 0.05
                }, 0);
              button_offset += h1_duration;
            }
            if (item.querySelector('p:not(.subheading)')) {

              let p_duration = 0.5 + ((item.querySelectorAll('p:not(.subheading) .line-child div').length - 1) * 0.02);
              tl
                .from(item.querySelectorAll('p:not(.subheading) .line-child div'), {
                  duration: p_duration,
                  yPercent: '100',
                  stagger: 0.02
                }, 0);
              button_offset += p_duration;
            }
            if (item.querySelectorAll('.button')) {
              tl
                .fromTo(item.querySelectorAll('.button'), {
                  opacity: 0
                }, {
                  duration: 0.5,
                  opacity: 1,
                  stagger: 0.05
                }, '-=0.4');
            }
            item.dataset.timeline = tl;
          });
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      let flkty = Flickity.data(slideshow),
        active_slide = flkty.selectedElement;
      document.fonts.ready.then(function () {
        animations[i].restart();
      });
    }
    animateReverse(i, animations) {
      animations[i].reverse();
    }
    centerArrows(flickity, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,

        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;

      flickity.cells.forEach((item, i) => {
        if (item.size.height > max_height) {
          max_height = item.size.height;
        }
      });

      if (max_height > image_height) {
        let difference = (max_height - image_height) / -2;

        if (prev_button) {
          prev_button.style.transform = 'translateY(' + difference + 'px)';
        }
        if (next_button) {
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}
